import React from 'react';
import AppLandingPage from './components/AppLandingPage';

function App() {
  return (
    <div className="App">
      <AppLandingPage />
    </div>
  );
}

export default App;
